import { MemoizedSelector, createFeatureSelector } from '@ngrx/store';
import { CLIENT_AUTH_FEATURE, ClientAuthState, StateWithClientAuth } from '../client-auth-state';

export const getClientAuthState: MemoizedSelector<StateWithClientAuth, ClientAuthState> =
  createFeatureSelector<ClientAuthState>(CLIENT_AUTH_FEATURE);
